import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const ViewPKS = ({ rowID, closePKS }) => { 
    const [formData, setFormData] = useState(null)

    useEffect(() => {
        getPksData()
    }, [rowID])

    const getPksData = async () => {
        try {
            // Asumsi lu punya API untuk ambil data PKS berdasarkan requestProcurementId atau pksId
            const response = await axiosJWT.get(`/api/pks/detail/${rowID}`)
            setFormData(response.data)
        } catch (err) {
            console.error("Gagal ambil data PKS")
        }
    }

    if (!formData) return <p>Loading data...</p>

    return (
        <div className="form-horizontal">
            <div className="row">
                <div className="form-group col-md-12">
                    <label className="control-label">Nama Barang/Jasa</label>
                    <input type="text" className="form-control" value={formData.namaBarangJasa} readOnly />
                </div>

                <div className="form-group col-md-6">
                    <label className="control-label">Tanggal Mulai</label>
                    <input type="date" className="form-control" value={formData.tanggalMulai.split('T')[0]} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Tanggal Selesai</label>
                    <input type="date" className="form-control" value={formData.tanggalSelesai.split('T')[0]} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Durasi</label>
                    <input type="text" className="form-control" value={formData.durasiKontrak} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Masa Cacat (Hari)</label>
                    <input type="text" className="form-control" value={formData.masaCacatHari} readOnly />
                </div>

                {/* Tabel Detail (Read Only) */}
                <div className="col-md-12">
                    <label className="control-label">Rincian Barang/Jasa</label>
                    <table className="table table-bordered">
                        <thead><tr><th>Nama Barang</th><th>Spek</th><th>Satuan</th><th>Harga</th><th>Vol</th><th>Total</th></tr></thead>
                        <tbody>
                            {formData.detailBarang.map((item, idx) => (
                                <tr key={idx}>
                                    <td><input type="text" className="form-control" value={item.namaBarang} readOnly /></td>
                                    <td><input type="text" className="form-control" value={item.spesifikasiTeknis} readOnly /></td>
                                    <td><input type="text" className="form-control" value={item.satuan} readOnly /></td>
                                    <td><input type="number" className="form-control" value={item.hargaSatuan} readOnly /></td>
                                    <td><input type="number" className="form-control" value={item.volume} readOnly /></td>
                                    <td>{item.totalHarga.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Penandatangan */}
                <div className="form-group col-md-6">
                    <label className="control-label">Nama Penandatangan Pihak 1</label>
                    <input type="text" className="form-control" value={formData.namaPenandatanganPihak1} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Jabatan Pihak 1</label>
                    <input type="text" className="form-control" value={formData.jabatanPihak1} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Nama Penandatangan Pihak 2</label>
                    <input type="text" className="form-control" value={formData.namaPenandatanganPihak2} readOnly />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Jabatan Pihak 2</label>
                    <input type="text" className="form-control" value={formData.jabatanPihak2} readOnly />
                </div>
            </div>

            <div className="modal-footer">
                <button className="btn btn-raised btn-danger br-2" type="button" onClick={closePKS}><i className="fa fa-times"></i> Tutup</button>
            </div>
        </div>
    )
}